<template>
  <div>
    <b-button v-b-modal.modal-scrollable variant="link" cy-id="terms">{{ $t("prewoesTermsAndConditions") }}</b-button>

    <b-modal id="modal-scrollable" size="lg" scrollable title="PreWoes användarvillkor samt integritetspolicy">
      <h3>Användarvillkor</h3>
      I denna integritetsförklaring, beskriver vi, PreWoe AB. (”PreWoe”), vår datainsamling och användningsmetoder med
      avseende på personuppgifter som vi samlar in via www.prewoe.com och andra offentligt tillgängliga webbsidor som
      direkt länkar till detta uttalande (kollektivt ”webbplatsen”). Detta uttalande beskriver hur PreWoe samlar in,
      använder och lagrar personlig information och annan information du tillhandahåller på webbplatsen. Den beskriver
      också de tillgängliga alternativen för din användning av din personliga information och hur du kan komma åt och
      uppdatera denna information. Detta uttalande täcker endast information som samlas in via webbplatsen och inte
      information som vi samlar in offline, via andra webbplatser eller genom våra prenumerationstjänster. PreWoe kommer
      att använda data som laddas av kunder i våra prenumerationstjänster i enlighet med avtalet (e) mellan PreWoe och
      den kunden.
      <h6 class="mt-4">Information som delar</h6>
      Du kan besöka webbplatsen utan att registrera eller aktivt skicka personuppgifter till oss. Om du inte registrerar
      dig får vi bara information som din dator eller annan enhet skickar till oss i samband med åtkomstbegäranden och
      via cookies och annan teknik som vi använder för att analysera och förbättra din användning av vår webbplats. När
      du begär information om PreWoes prenumerationstjänster kan vi be om personlig information, till exempel ditt namn,
      e-post, företag, titel, telefonnummer, land och bransch. Du kan välja att tillhandahålla personlig information
      genom att inte ange den när du blir frågan. Vi kan också samla in, från dig, följande personliga information om
      dina hänvisningar: [Namn och e-postadress], för att hänvisa våra produkter eller tjänster till dessa hänvisade
      personer. När du förser oss med personlig information om dina hänvisade personer använder vi endast denna
      information av den specifika anledningen till vilken den tillhandahålls Om du tror att en av dina affärskontakter
      har gett oss din personliga information och du vill begära att den tas bort från vår databas, vänligen kontakta
      oss på support@PreWoe.com. Teknologier som kakor, fyrvärden eller liknande tekniker används av PreWoe och våra
      partners, dotterbolag eller analyser eller tjänsteleverantörer (t.ex. marknadsföringspartners). Denna teknik
      används för att analysera trender, administrera webbplatsen, spåra användarnas rörelser runt webbplatsen och för
      att samla in demografisk information om vår användarbas som helhet. Vi kan få rapporter baserade på användningen
      av denna teknik av dessa företag såväl på individuell som aggregerad basis. Vi använder också cookies för
      reklamändamål. Användare kan kontrollera användningen av cookies på individuell webbläsarnivå. Om du avvisar
      cookies kan du fortfarande använda vår webbplats, men din förmåga att använda vissa funktioner eller områden på
      vår webbplats kan vara begränsad. Vi samarbetar med tredje parter för att visa reklam på vår webbplats eller för
      att hantera vår annonsering på andra webbplatser. Våra tredjepartspartners kan använda teknik som cookies för att
      samla information om dina aktiviteter på denna webbplats och andra webbplatser för att ge dig reklam baserat på
      dina surfaktiviteter och intressen. Om du inte vill använda den här informationen för att visa dina
      intressebaserade annonser kan du välja bort detta genom att klicka här (eller om du är belägen i EU klicka här).
      Observera att detta inte väljer att inte visas annonser. Du fortsätter att få generiska annonser. Mer information
      om hur du hanterar cookies på webbplatsen finns i vår cookiepolicy (www.prewoe.com/cookie/). Som det gäller för de
      flesta webbplatser samlar vi in viss information automatiskt och lagrar den i loggfiler. Denna information kan
      inkludera internetprotokoll (IP) adresser, webbläsartyp, internetleverantör (ISP), referens- / utgångssidor,
      operativsystem, datum / tidstämpel och / eller klickströmdata. Vi kan kombinera denna automatiskt insamlade
      logginformation med annan information som vi samlar in om dig. Vi använder lokal lagring, till exempel HTML5, för
      att lagra innehållsinformation och preferenser. Tredjeparter som vi samarbetar med för att tillhandahålla vissa
      funktioner på vår webbplats eller för att visa reklam baserat på din webbsökningsaktivitet använder också HTML5
      för att samla in och lagra information. Olika webbläsare kan erbjuda sina egna hanteringsverktyg för att ta bort
      HTML5. Vi kanske inte känner igen eller vidtar åtgärder som svar på Do-Not-Track (DNT) -signaler från webbläsare.
      För närvarande finns det inte någon allmänt accepterad standard för ett företags antagande för hur man ska svara
      när en DNT-signal upptäcks. I händelse av att en slutlig standard upprättas kommer vi att bestämma hur vi ska
      reagera på dessa signaler på lämpligt sätt.
      <h6 class="mt-4">Information som vi delar</h6>
      Vi avslöjar din personliga information endast enligt följande: – Med ditt samtycke. – Genom att använda anslutna
      och icke-anslutna tjänsteleverantörer runt om i världen som hjälper oss att leverera vår tjänst och driva vår
      verksamhet, med förbehåll för sekretessavtal. – Vi delar aggregerad användningsstatistik. – Vi kommer att avslöja
      information enligt lag eller för att skydda dig, andra användare, oss eller tredje parter från skada, inklusive
      bedrägeri, datasäkerhetsbrott eller där någons fysiska säkerhet verkar vara i fara. – Vid en omorganisation eller
      försäljning av vårt företag eller tillgångar kan dina uppgifter överföras, förutsatt att den förvärvaren
      accepterar de åtaganden som gjorts i denna uttalande och uppfyller tillämplig lag.
      <h6 class="mt-4">Widgets</h6>
      Vår webbplats innehåller sociala mediefunktioner, till exempel Facebook-knappen och widgetar, till exempel
      Dela-knappen eller interaktiva miniprogram som körs på vår webbplats. Dessa funktioner kan samla in din IP-adress,
      vilken sida du besöker på vår webbplats och kan ställa in en cookie för att funktionen ska fungera korrekt.
      Sociala mediefunktioner och widgets är antingen värd av en tredje part eller värd direkt på vår webbplats. Dina
      interaktioner med dessa funktioner styrs av integritetsförklaringen för det företag som tillhandahåller det.
      <h6 class="mt-4">Länkar till andra webbplatser</h6>
      Vi kan tillhandahålla länkar på vår webbplats till vissa tredjepartswebbplatser eller hänvisningar till vissa
      tredjeparts produkter eller tjänster. Om du väljer att besöka en tredje parts webbplats eller använda dess
      produkter eller tjänster kommer tredjeparts integritetsförklaring och inte detta uttalande att reglera dina
      aktiviteter och all information du avslöjar när du interagerar med tredje part.
      <h6 class="mt-4">Avsluta / Opt-Out</h6>
      Du kan välja att ta emot vårt nyhetsbrev eller marknadsföringsmeddelanden genom att följa anvisningarna längst ner
      i varje kommunikation eller när som helst via e-post support@PreWoe.com.
      <h6 class="mt-4">Säkerhet</h6>
      Säkerheten för din personliga information är viktig för oss. Vi följer allmänt accepterade standarder för att
      skydda den personliga information som skickas till oss, både under överföring och när den har mottagits. Om du har
      några frågor om säkerheten för din personliga information kan du kontakta oss på legal@prewoe.com.
      <h6 class="mt-4">Datalagring</h6>
      Vi kommer att behålla din information så länge som behövs för att tillhandahålla dig tjänster och uppfylla de
      syften som beskrivs i denna uttalande. Vi kommer att behålla och använda din information enligt vad som krävs
      eller tillåts enligt tillämplig lag, inklusive för att följa våra lagliga eller affärsregistrerade skyldigheter,
      lösa tvister och verkställa våra avtal.
      <h6 class="mt-4">Radera eller uppdatera din information</h6>
      Om din personlig identifierbara information ändras, eller om du inte längre önskar vår tjänst, kan du korrigera,
      uppdatera, avbryta användningen av vår tjänst eller ta bort den genom att göra ändringen på vår
      medlemsinformationssida eller genom att skicka e-post till vår kundsupport på support@prewoe.com. Vi kommer att
      svara på din begäran om åtkomst inom 30 dagar.
      <h6 class="mt-4">Ändring av avtalet</h6>
      Vi kan uppdatera detta avtal med jämna mellanrum och utan föregående meddelande till dig för att återspegla
      förändringar i vår personalinformation. Om vi gör väsentliga ändringar av denna uttalande, kommer vi att meddela
      dig här, via e-post eller med ett meddelande på vår hemsida innan ändringen träder i kraft. Du bör granska
      uttalandet varje gång du besöker vår webbplats för att få reda på eventuella förändringar.

      <h3 class="mt-4">Integritetspolicy</h3>

      <h6 class="mt-4">Information om behandling av personuppgifter</h6>
      Som kund hos PreWoe AB (Företaget) samlas vissa personuppgifter in och behandlas på olika sätt. Nedan följer
      information om behandlingen samt om dina rättigheter som registrerad.
      <h6 class="mt-4">Personuppgiftsansvarig</h6>
      Denna integritetspolicy är gällande för:
      <br />
      PreWoe AB med organisationsnummer 559247-9868
      <br />
      Dataskyddsansvarig kan kontaktas via e-postadress privacy@prewoe.com.
      <br />
      För ytterligare information om Företagets hantering av personuppgifter, se vid var tid gällande integritetspolicy.
      Om du har synpunkter på hur Företaget hanterar dina personuppgifter har du möjlighet att vända dig till
      Datainspektionen.
      <h6 class="mt-4">Ändamål med behandlingen och laglig grund</h6>
      Som kund hos Företaget behandlas dina uppgifter i den mån det är nödvändigt för att administrera kundförhållandet
      och för att Företaget ska kunna uppfylla sina åtaganden gentemot dig. Därutöver används uppgifterna för att
      Företaget ska kunna erbjuda personligt anpassade erbjudanden till dig som kund. Behandlingen grundas på det avtal
      eller det kundförhållande som uppstår vid exempelvis en beställning som kunden gör hos Företaget. Marknadsföring
      skickas till dig som kund grundat på antingen ett uttryckligt samtycke eller en intresseavvägning genomförd av
      Företaget.
      <br />

      Vilka personuppgifter som behandlas varierar beroende på vilken företagsform du har. Kund- och företagsuppgifter
      kan bli personuppgifter för kund och affärspart som är en enskild firma. När du beställer tjänster samlar vi in
      kontaktuppgifter om dig som kontaktperson och företagsuppgifter om dig som blir kund.
      <h6 class="mt-4">Användare av Företagets tjänster</h6>
      Alla användare har användaruppgifter och online-identifikationer hos oss för att kunna använda Företagets
      tjänster. När du använder en tjänst samlar vi in uppgifter om ditt beteendemönster, det vill säga vad du gör och
      hur du använder en tjänst. Exempel på uppgifter som vi samlar in är hur du klickar dig runt mellan olika sidor och
      funktioner i program, på vilket sätt du använder funktioner, vilka tidpunkter du loggar in och ut och hur länge du
      är inloggad samt från vilken enhet du loggar in.
      <h6 class="mt-4">Hur länge sparar vi dina personuppgifter?</h6>
      Hur länge dina personuppgifter lagras hos oss varierar beroende på syftet till att de samlats in. Företaget sparar
      personuppgifter om dig som kund så länge det finns en kundrelation eller är nödvändigt för att uppnå de ändamål
      som beskrivs i denna integritetspolicy. Vid avtalets upphörande kommer dina uppgifter om dig som kund och
      kontaktperson lagras under den tid som krävs eller är tillåten enligt vid var tid gällande lagstiftning och
      praxis. Du blir en potentiell kund tills du invänder mot denna behandling.
      <h6 class="mt-4">Sekretess</h6>
      Personuppgifter som behandlas av Företaget är konfidentiella och är inte tillgängliga för fler individer än vad
      som är nödvändigt för att uppfylla fastställda ändamål. Företaget erbjuder en säker plattform med funktioner för
      sökbarhet, uppföljning och kontroll. Personuppgifter är därför säkra på ett ställe i stället för att spridas till
      e-post, servrar och hårddiskar.
      <h6 class="mt-4">Tekniska och organisatoriska säkerhetsåtgärder</h6>
      Företaget vidtar lämpliga tekniska och organisatoriska informationssäkerhetsåtgärder för att förhindra och
      begränsa risker avseende obehörig åtkomst, avslöjande, missbruk, förändringar och förstörelse. Endast behörig
      personal bundna av sekretess har tillgång till identifierbara personuppgifter.
      <h6 class="mt-4">Överföring av uppgifter</h6>
      Uppgifterna kan komma att lämnas ut till eventuella samarbetspartners som levererar stödtjänster till Företaget,
      såsom IT-tjänster, på det sätt och i den omfattning som krävs för att Företaget ska kunna fullfölja sina åtaganden
      gentemot dig som kund samt i marknadsföringssyfte.
      <h6 class="mt-4">Överföringar till tredje land</h6>
      Företaget strävar efter att inte överföra uppgifter till ett land eller bolag placerat utanför EU/EES. Om det ändå
      skulle uppstå ett behov av en sådan överföring, förutsätter det att Företaget innan överföring uppfyller
      Dataskyddsförordningens krav och åtgärder med anledning av en sådan överföring.
      <h6 class="mt-4">Dina rättigheter som registrerad</h6>
      När företaget samlar in och behandlar dina personuppgifter har du vissa rättigheter. Du har rätt att:
      <br />
      - Begära ett utdrag över de personuppgifter företaget behandlar samt på vilket sätt de behandlas;
      <br />
      - Begära rättelse av eventuellt felaktiga uppgifter;
      <br />
      - Begära att bli raderad, men radering av personuppgifter kan inte ske om det krävs för att fullgöra avtalet eller
      om annan svensk eller europeisk lag, domstols- eller myndighetsbeslut säger annat eller om det baseras på
      intresseavvägning. Skulle du tycka att det inte finns berättigade skäl eller att intresseavvägningen är felaktig
      har du rätt att invända mot behandlingen;
      <br />
      - Begära att behandlingen under vissa omständigheter begränsas, t.ex. under tiden en fråga om huruvida uppgifter
      är korrekta; och
      <br />
      - Rätten till dataportabilitet, vilket innebär att det ska vara möjligt att extrahera sina uppgifter i ett
      strukturerat format till en annan tjänst.
      <br />
      Företagets plattform strukturerar personuppgifter på ett sådant sätt att det är möjligt för borttagning och
      dataportabilitet utifrån de krav som ställs i Dataskyddsförordningen.
      <br />
      Vid frågor angående hanteringen av dina personuppgifter, vänligen kontakta Företaget via e-post;
      privacy@prewoe.com.
      <h3 class="mt-4">Kontaktinformation</h3>
      Om du har frågor, problem eller förslag relaterade till användarvillkoren eller personuppgiftsbiträdesavtalet kan
      du kontakta oss på: PreWoe AB
      <br />
      Huskvarnavägen 82,
      <br />
      554 66 Jönköping
      <br />
      +46 072 37 67 421
      <br />
      support@prewoe.com
      <br />

      <template v-slot:modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="outline-secondary" @click="cancel()">
          <i class="fa fa-times"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Terms",
  components: {},
  data() {
    return {
      tabIndex: 0
    };
  }
};
</script>
